import React from "react";

import { Modal } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { CommonTypes } from "@assets/types";

type Props = {
  company: string;
  onClose: CommonTypes.CallbackFunction;
  onSwitchCompany: CommonTypes.CallbackFunction;
  isLoading: boolean;
};

const SwitchCompanyModal = ({
  company,
  onClose,
  onSwitchCompany,
  isLoading,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      closeIcon
      corner="sharp"
      divided
      onClose={onClose}
      open
      primaryButtonProps={{
        children: t("LABEL_SWITCH_COMPANY"),
        onClick: onSwitchCompany,
        loading: isLoading,
      }}
      secondaryButtonProps={{
        children: t("LABEL_CANCEL"),
        onClick: onClose,
      }}
      title={t("LABEL_SWITCH_COMPANY")}
    >
      <p className="text-neutral-900">
        {t("LABEL_TEMPLATE_ASSOCIATED_TO_COMPANY_N", {
          n: company,
        })}
      </p>
    </Modal>
  );
};

export default SwitchCompanyModal;
